'use client';
import React from 'react';
import { Layout } from 'antd';
import styles from './About.module.scss';
import { ShieldIcon, TrendingUpIcon, ZapIcon } from '@/shared/constants/icon';
import { AboutDataType } from './types';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';

const { Content } = Layout;


export function About() {
  const t = useTranslations('about');
  const DATA_OF_ABOUT: AboutDataType[] = [
    {
      id: 1,
      icon: <ShieldIcon size={'1dvw'} color="var(--color-cream)"/>,
      title: t('item1.title'),
      desc: t('item1.desc')
    },
    {
      id: 2,
      icon: <ZapIcon size={'1dvw'} color="var(--color-cream)"/>,
      title: t('item2.title'),
      desc: t('item2.desc')
    },
    {
      id: 3,
      icon: <TrendingUpIcon size={'1dvw'} color="var(--color-cream)"/>,
      title: t('item3.title'),
      desc: t('item3.desc')
    },
  ];

  return (
    <Content className={styles.root} id="about">
      <section className={styles.root_container}>
        <div className={styles.root_line}/>
        <h2>{t('title')}</h2>
        <h3>{t('desc1')}</h3>
        <h3>{t('desc2')}</h3>
      </section>
      <section className={styles.root_cards}>
        {DATA_OF_ABOUT.map((item) => 
          <ScrollReveal variant="fadeUp" key={item.id}>
            <div  className={styles.root_cards_item}>
              <figure className={styles.root_cards_item_icon}>
                {item.icon}
              </figure>
              <div className={styles.root_cards_item_box}>
                <h3>{item.title}</h3>
                <h4>{item.desc}</h4>
              </div>
            </div>
          </ScrollReveal>
        )}
      </section>
    </Content>
  );
}
